export const smallScreenBreakpoints = [
    'xs',
    'sm'
];
